import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Breadcrumbs, Link, Skeleton, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import { useContactById } from '@/queries/contacts';
import ContactProfileSection from './ContactProfileSection';
import RelatedContactsSection from './RelatedContactsSection';

export default function ContactDetails() {
    const navigate = useNavigate();
    const { contactId } = useParams();

    const { data: contact, isLoading, isError } = useContactById({ contactId });

    if (isError) {
        return <NotFound />;
    }

    if (isLoading || !contact) {
        return (
            <Box sx={{ p: 3 }}>
                <Skeleton variant="text" width={200} height={32} />
                <Skeleton variant="rectangular" height={240} sx={{ mt: 2 }} />
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box
                sx={{
                    backgroundColor: 'neutral.white',
                    padding: '16px 24px',
                    borderBottom: '1px solid',
                    borderColor: 'neutral.borderColor',
                }}
            >
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" sx={{ color: 'neutral.gray' }} />}
                >
                    <Link
                        underline="none"
                        sx={{
                            fontSize: 14,
                            fontWeight: 400,
                            color: 'neutral.gray',
                            lineHeight: '20px',
                            cursor: 'pointer',
                        }}
                        onClick={() => navigate('/contacts')}
                    >
                        Contacts
                    </Link>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.primary',
                            fontWeight: 500,
                        }}
                    >
                        {contact.contactName}
                    </Typography>
                </Breadcrumbs>
                <Stack spacing={0.5} mt={1}>
                    <Typography variant="h2">{contact.contactName}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {contact.contactEmail}
                        {contact.prospect.prospectName ? ` · ${contact.prospect.prospectName}` : ''}
                    </Typography>
                </Stack>
            </Box>
            <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
                <Stack spacing={3}>
                    <ContactProfileSection profile={contact} isPrimary={contact.isPrimary} />
                    <RelatedContactsSection relatedContacts={contact.relatedContacts} />
                </Stack>
            </Box>
        </Box>
    );
}
